import React, { useEffect, useState } from 'react'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import SpecializationList from './SpecializationList'
import { CoursesManangementVM } from '../../../Structure/ViewModels/Admin/CoursesManagementVM'
import SimpleCustomizingList from './SimpleCustomizingList'
import PackagesLists from './PackagesLists'
import CoursesList from './CoursesList'
import { CoursesListVM } from '../../../Structure/ViewModels/Admin/CoursesListVM'
import InstitutionsList from './InstitutionsList'
import { Globals } from '../../../Structure/Globals/GlobalObs'

const CoursesManagementPage = () => {
  const [vm, setVm] = useState<{viewModel:CoursesManangementVM}>({viewModel:new CoursesManangementVM()})
  const control = vm.viewModel
  useEffect(()=>{
    control.subscribeUpdate(setVm)
    control.load()
  },[])

  const coursesListVm:CoursesListVM = new CoursesListVM()

  return (
    <Container className='py-5'>{
      control.Show(
        <Row className='p-0 m-0  py-3'>
          <Accordion defaultActiveKey={'0'} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
            <Accordion.Item eventKey='0' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} >
              <Accordion.Button  className='border-0 border-bottom' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
                <h5 className='ps-3 px-2'>التخصصات</h5>
              </Accordion.Button>
              <Accordion.Body  className=' d-flex flex-column justify-content-between overflow-y-auto' style={{maxHeight:'400px'}}>
                <Row className='h-100 justify-content-between'>
                  {
                    Globals.auth.User?.permissions.some(a=>a.id=='10')?(
                      <Col lg={7} className='p-1 h-100 d-flex flex-column'>
                        <SimpleCustomizingList vm={control} list={control.Specializations} dataType='التخصص'/>
                      </Col>  
                    ):(null)
                  }
                  {
                    Globals.auth.User?.permissions.some(a=>a.id=='11')?(
                      <Col lg={5} className='p-1 h-100 d-flex flex-column'>
                        <SimpleCustomizingList  vm={control} list={control.Levels}  dataType='المستوى'/>
                      </Col>
                    ):(null)
                  }
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion> 
          
          {
            Globals.auth.User?.permissions.some(a=>a.id=='13')?(
              <Row className='p-0 m-0 py-3'>
                <CoursesList vm={coursesListVm} />
              </Row>
            ):(null)
          }
          {
            Globals.auth.User?.permissions.some(a=>a.id=='12')?(
              <Row className='p-0 m-0 py-3'>
                <PackagesLists vm={control} coursesVM={coursesListVm}/>
              </Row>
            ):(null)
          }
          {
            Globals.auth.User?.permissions.some(a=>a.id=='25')?(
              <Row className='p-0 m-0 py-3'>
                <InstitutionsList vm={control}/>
              </Row>
            ):(null)
          }
        </Row>
      ) }
    </Container>
  )
}

export default CoursesManagementPage
